import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "accommodation-details my-4" };
const _hoisted_2 = { class: "row g-4" };
const _hoisted_3 = { class: "col-12 col-lg-7" };
const _hoisted_4 = { class: "lead" };
const _hoisted_5 = { class: "accommodation-info" };
const _hoisted_6 = { class: "info-item mb-3" };
const _hoisted_7 = { class: "mb-2" };
const _hoisted_8 = { class: "mb-2" };
const _hoisted_9 = { class: "mb-0" };
const _hoisted_10 = { class: "info-item mb-3" };
const _hoisted_11 = { class: "mb-2" };
const _hoisted_12 = { class: "mb-2" };
const _hoisted_13 = { class: "mb-0" };
const _hoisted_14 = { class: "info-item" };
const _hoisted_15 = { class: "mb-2" };
const _hoisted_16 = {
    key: 0,
    class: "social-links mt-3"
};
const _hoisted_17 = { class: "d-flex flex-wrap gap-2" };
const _hoisted_18 = ["href"];
const _hoisted_19 = ["href"];
const _hoisted_20 = ["href"];
const _hoisted_21 = ["href"];
const _hoisted_22 = { class: "col-12 col-lg-5" };
const _hoisted_23 = {
    class: "card p-4 mb-3",
    style: { "background": "var(--bg-secondary)" }
};
const _hoisted_24 = { class: "accommodation-info" };
const _hoisted_25 = { class: "mb-2" };
const _hoisted_26 = { class: "text-primary" };
const _hoisted_27 = { class: "text-primary" };
const _hoisted_28 = { class: "card p-4 mb-3" };
const _hoisted_29 = { class: "mb-2" };
const _hoisted_30 = { class: "mb-0 text-muted" };
const _hoisted_31 = { class: "card p-4" };
const _hoisted_32 = { class: "d-flex align-items-center mb-3" };
const _hoisted_33 = { class: "d-flex align-items-center mb-3" };
const _hoisted_34 = { class: "d-flex align-items-center mb-3" };
const _hoisted_35 = { class: "d-flex align-items-center mb-3" };
const _hoisted_36 = {
    key: 0,
    class: "mt-3 pt-3 border-top"
};
const _hoisted_37 = { class: "d-flex flex-wrap gap-2" };
const _hoisted_38 = ["href"];
const _hoisted_39 = ["href"];
const _hoisted_40 = ["href"];
const _hoisted_41 = ["href"];
import { computed } from 'vue';
// Props para recibir el hotel
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccommodationDetails',
    props: {
        accommodation: {}
    },
    setup(__props) {
        const props = __props;
        // Computed properties para mostrar los datos reales del hotel
        const accommodationDescription = computed(() => {
            return props.accommodation?.description || 'Descripción no disponible';
        });
        const accommodationType = computed(() => {
            const type = props.accommodation?.room_type || props.accommodation?.badge || 'hotel';
            return type.charAt(0).toUpperCase() + type.slice(1);
        });
        const accommodationPrice = computed(() => {
            const price = props.accommodation?.price_per_night;
            if (!price || price === '0.00') {
                return 'Consultar precio';
            }
            const numPrice = Math.abs(parseFloat(price));
            if (isNaN(numPrice))
                return 'Consultar precio';
            return `$${numPrice.toFixed(0)}/noche`;
        });
        const accommodationCapacity = computed(() => {
            const capacity = props.accommodation?.capacity;
            if (!capacity || capacity === 0) {
                return 'Consultar';
            }
            return `${capacity} personas`;
        });
        const accommodationLocation = computed(() => {
            console.log('locacion ', props.accommodation?.whatsapp);
            return props.accommodation?.location || 'Ubicación no disponible';
        });
        const accommodationAddress = computed(() => {
            return props.accommodation?.place?.address || 'Dirección no disponible';
        });
        const accommodationHours = computed(() => {
            return props.accommodation?.place?.opening_hours || 'Horarios no disponibles';
        });
        const accommodationContact = computed(() => {
            return props.accommodation?.whatsapp || 'Contacto no disponible';
        });
        // Computed properties para redes sociales
        const accommodationWebsite = computed(() => {
            return props.accommodation?.website || props.accommodation?.link || null;
        });
        const accommodationFacebook = computed(() => {
            return props.accommodation?.facebook || null;
        });
        const accommodationInstagram = computed(() => {
            return props.accommodation?.instagram || null;
        });
        const accommodationWhatsapp = computed(() => {
            return props.accommodation?.whatsapp || null;
        });
        const hasSocialLinks = computed(() => {
            return accommodationWebsite.value || accommodationFacebook.value || accommodationInstagram.value || accommodationWhatsapp.value;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "visually-hidden" }, "Descripción del hotel", -1)),
                        _createElementVNode("p", _hoisted_4, _toDisplayString(accommodationDescription.value), 1),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "h6 mb-2" }, [
                                    _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                                    _createTextVNode("Información del Hotel ")
                                ], -1)),
                                _createElementVNode("p", _hoisted_7, [
                                    _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Tipo:", -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationType.value), 1)
                                ]),
                                _createElementVNode("p", _hoisted_8, [
                                    _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Precio:", -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationPrice.value), 1)
                                ]),
                                _createElementVNode("p", _hoisted_9, [
                                    _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Capacidad:", -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationCapacity.value), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "h6 mb-2" }, [
                                    _createElementVNode("i", { class: "fas fa-map-marker-alt me-2" }),
                                    _createTextVNode("Ubicación ")
                                ], -1)),
                                _createElementVNode("p", _hoisted_11, [
                                    _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Lugar:", -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationLocation.value), 1)
                                ]),
                                _createElementVNode("p", _hoisted_12, [
                                    _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Dirección:", -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationAddress.value), 1)
                                ]),
                                _createElementVNode("p", _hoisted_13, [
                                    _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Horarios:", -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationHours.value), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                                _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "h6 mb-2" }, [
                                    _createElementVNode("i", { class: "fas fa-phone me-2" }),
                                    _createTextVNode("Contacto ")
                                ], -1)),
                                _createElementVNode("p", _hoisted_15, [
                                    _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Teléfono:", -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationContact.value), 1)
                                ]),
                                (hasSocialLinks.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _cache[13] || (_cache[13] = _createElementVNode("h5", { class: "h6 mb-2 text-muted" }, "Síguenos", -1)),
                                        _createElementVNode("div", _hoisted_17, [
                                            (accommodationWebsite.value)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    href: accommodationWebsite.value,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    class: "social-link social-website"
                                                }, _cache[9] || (_cache[9] = [
                                                    _createElementVNode("i", { class: "fas fa-globe me-1" }, null, -1),
                                                    _createTextVNode(" Sitio Web ", -1)
                                                ]), 8, _hoisted_18))
                                                : _createCommentVNode("", true),
                                            (accommodationFacebook.value)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 1,
                                                    href: accommodationFacebook.value,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    class: "social-link social-facebook"
                                                }, _cache[10] || (_cache[10] = [
                                                    _createElementVNode("i", { class: "fab fa-facebook-f me-1" }, null, -1),
                                                    _createTextVNode(" Facebook ", -1)
                                                ]), 8, _hoisted_19))
                                                : _createCommentVNode("", true),
                                            (accommodationInstagram.value)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 2,
                                                    href: accommodationInstagram.value,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    class: "social-link social-instagram"
                                                }, _cache[11] || (_cache[11] = [
                                                    _createElementVNode("i", { class: "fab fa-instagram me-1" }, null, -1),
                                                    _createTextVNode(" Instagram ", -1)
                                                ]), 8, _hoisted_20))
                                                : _createCommentVNode("", true),
                                            (accommodationWhatsapp.value)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 3,
                                                    href: accommodationWhatsapp.value,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    class: "social-link social-whatsapp"
                                                }, _cache[12] || (_cache[12] = [
                                                    _createElementVNode("i", { class: "fab fa-whatsapp me-1" }, null, -1),
                                                    _createTextVNode(" WhatsApp ", -1)
                                                ]), 8, _hoisted_21))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "h5 mb-3" }, [
                                _createElementVNode("i", { class: "fas fa-bed me-2" }),
                                _createTextVNode("Información del Hotel ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("p", _hoisted_25, [
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(accommodationType.value), 1),
                                    _cache[16] || (_cache[16] = _createTextVNode(" - ", -1)),
                                    _createElementVNode("span", _hoisted_27, _toDisplayString(accommodationPrice.value), 1)
                                ]),
                                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "mb-0" }, null, -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                            _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "h5 mb-3" }, [
                                _createElementVNode("i", { class: "fas fa-map-marker-alt me-2" }),
                                _createTextVNode("Ubicación ")
                            ], -1)),
                            _createElementVNode("p", _hoisted_29, [
                                _createElementVNode("strong", null, _toDisplayString(accommodationLocation.value), 1)
                            ]),
                            _createElementVNode("p", _hoisted_30, [
                                _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-map-pin me-1" }, null, -1)),
                                _createTextVNode(_toDisplayString(accommodationAddress.value), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                            _cache[34] || (_cache[34] = _createElementVNode("h3", { class: "h5 mb-3" }, [
                                _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                                _createTextVNode("Información Adicional ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_32, [
                                _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-tag me-2" }, null, -1)),
                                _createElementVNode("span", null, [
                                    _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Tipo:", -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationType.value), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                                _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fas fa-dollar-sign me-2" }, null, -1)),
                                _createElementVNode("span", null, [
                                    _cache[23] || (_cache[23] = _createElementVNode("strong", null, "Precio:", -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationPrice.value), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                                _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fas fa-phone me-2" }, null, -1)),
                                _createElementVNode("span", null, [
                                    _cache[25] || (_cache[25] = _createElementVNode("strong", null, "Contacto:", -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationContact.value), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                                _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fas fa-clock me-2" }, null, -1)),
                                _createElementVNode("span", null, [
                                    _cache[27] || (_cache[27] = _createElementVNode("strong", null, "Horarios:", -1)),
                                    _createTextVNode(" " + _toDisplayString(accommodationHours.value), 1)
                                ])
                            ]),
                            (hasSocialLinks.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _cache[33] || (_cache[33] = _createElementVNode("h5", { class: "h6 mb-3 text-muted" }, "Síguenos", -1)),
                                    _createElementVNode("div", _hoisted_37, [
                                        (accommodationWebsite.value)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                href: accommodationWebsite.value,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                class: "social-link social-website"
                                            }, _cache[29] || (_cache[29] = [
                                                _createElementVNode("i", { class: "fas fa-globe me-1" }, null, -1),
                                                _createTextVNode(" Web ", -1)
                                            ]), 8, _hoisted_38))
                                            : _createCommentVNode("", true),
                                        (accommodationFacebook.value)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                href: accommodationFacebook.value,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                class: "social-link social-facebook"
                                            }, _cache[30] || (_cache[30] = [
                                                _createElementVNode("i", { class: "fab fa-facebook-f me-1" }, null, -1),
                                                _createTextVNode(" FB ", -1)
                                            ]), 8, _hoisted_39))
                                            : _createCommentVNode("", true),
                                        (accommodationInstagram.value)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 2,
                                                href: accommodationInstagram.value,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                class: "social-link social-instagram"
                                            }, _cache[31] || (_cache[31] = [
                                                _createElementVNode("i", { class: "fab fa-instagram me-1" }, null, -1),
                                                _createTextVNode(" IG ", -1)
                                            ]), 8, _hoisted_40))
                                            : _createCommentVNode("", true),
                                        (accommodationWhatsapp.value)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 3,
                                                href: accommodationWhatsapp.value,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                class: "social-link social-whatsapp"
                                            }, _cache[32] || (_cache[32] = [
                                                _createElementVNode("i", { class: "fab fa-whatsapp me-1" }, null, -1),
                                                _createTextVNode(" WA ", -1)
                                            ]), 8, _hoisted_41))
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ]));
        };
    }
});
